module.exports = __webpack_public_path__ + "img/womanFace.9895d63b.png";